import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import TawlaGroups from "./TawlaGroups";
const defaultAutos = {
    Branches: [],
};

export default function TawlaCon() {

  const [branch, setBranch] = useState({ id: -1, name: "الكل" });
  const tb = {
    wait: true,
    other: true,
    Branch: true,
    Tawla: true,
    TawlaGroups:true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms:{
      iempid: sto.empi,
      tname: "tawla",
      branch:  branch.id == -1 ? sto.branchi : branch.id ,
      db_name: sto?.db_name,
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch],
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches 
  )
    return <LoadingPage />;

  return (
    <TawlaGroups
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        branch,
        setBranch,
        isGroups:false,
      }}
    />
  );
}
